import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "flag-icon flag-icon-us" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "flag-icon flag-icon-us mr-2" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "flag-icon flag-icon-de mr-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flag-icon flag-icon-fr mr-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "flag-icon flag-icon-es mr-2" }, null, -1)

export function render(_ctx, _cache) {
  const _component_app_dropdown = _resolveComponent("app-dropdown")

  return (_openBlock(), _createBlock(_component_app_dropdown, null, {
    "dropdown-button": _withCtx(() => [
      _hoisted_1
    ]),
    "dropdown-menu": _withCtx(() => [
      _createElementVNode("a", {
        href: "#",
        class: "dropdown-item active",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.changeLanguage('en')))
      }, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.$t("languages.english")), 1)
      ]),
      _createElementVNode("a", {
        href: "#",
        class: "dropdown-item",
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.changeLanguage('de')))
      }, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.$t("languages.german")), 1)
      ]),
      _createElementVNode("a", {
        href: "#",
        class: "dropdown-item",
        onClick: _cache[2] || (_cache[2] = $event => (_ctx.changeLanguage('fr')))
      }, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t("languages.french")), 1)
      ]),
      _createElementVNode("a", {
        href: "#",
        class: "dropdown-item",
        onClick: _cache[3] || (_cache[3] = $event => (_ctx.changeLanguage('es')))
      }, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.$t("languages.spanish")), 1)
      ])
    ]),
    _: 1
  }))
}